import PropTypes from 'prop-types';
import { CustomIcon } from '$src/components/CustomIcon';

import './Benefits.less';

function Benefits({ title, className }) {
  const benefits = [
    'Live video monitoring by US-based, highly-trained professionals, available 24/7',
    'Real-time deterrence using your cameras speaker and siren with emergency dispatch for escalated situations',
    'Instant SMS or phone call alerts about important incidents that require your attention',
  ];

  return (
    <div className={className}>
      <div className="benefits-title">{title}</div>
      {benefits.map((benefit, index) => (
        <div className="benefits-line" key={index}>
          <CustomIcon type="regular" name="check.svg" className="benefits-line-icon" />
          <p className="benefits-line-text">{benefit}</p>
        </div>
      ))}
    </div>
  );
}

Benefits.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

Benefits.defaultProps = {
  title: 'Benefits Include:',
};

export default Benefits;
